import { render, staticRenderFns } from "./rwzx.vue?vue&type=template&id=5115ec7e&scoped=true&"
import script from "./rwzx.vue?vue&type=script&lang=js&"
export * from "./rwzx.vue?vue&type=script&lang=js&"
import style0 from "./rwzx.vue?vue&type=style&index=0&id=5115ec7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5115ec7e",
  null
  
)

export default component.exports